module.exports = __webpack_public_path__ + "static/bg-home-hero-3-bb4b33b77274db09b969f629ad81c4d5.svg";